import React from 'react';
import EnquiryForm from '../components/EnquiryForm';
import { FaCheckCircle } from 'react-icons/fa';

const StartYourBrandPage = () => {
  const steps = [
    { number: '01', title: 'Idea Discussion', description: 'Share your vision, target market, and product requirements with our team', duration: '1-2 days' },
    { number: '02', title: 'Formulation Development', description: 'Choose from 68+ ready formulations or create custom blends with our R&D team', duration: '3-7 days' },
    { number: '03', title: 'Sampling', description: 'Receive product samples for testing and market validation', duration: '5-10 days' },
    { number: '04', title: 'Packaging Design', description: 'Finalize labels, packaging, and branding elements', duration: '7-14 days' },
    { number: '05', title: 'Regulatory Approval', description: 'Complete licensing, certifications, and compliance documentation', duration: '15-30 days' },
    { number: '06', title: 'Manufacturing', description: 'Production begins with quality control at every step', duration: '10-20 days' },
    { number: '07', title: 'Delivery', description: 'Timely delivery of finished products ready for market', duration: '2-5 days' },
  ];

  return (
    <div className="min-h-screen" data-testid="start-your-brand-page">
      <section className="bg-gradient-to-r from-[#0F5132] to-[#0F5132] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Launch Your Ayurvedic Brand in 7 Steps</h1>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto mb-8">
            From idea to market-ready products - we handle everything for you
          </p>
          <div className="inline-block px-6 py-3 bg-[#0F5132] rounded-lg font-semibold">
            Total Timeline: 45-90 days
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className="flex flex-col lg:flex-row items-start gap-8">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-[#0F5132] rounded-xl flex items-center justify-center text-[#0F5132] text-2xl font-bold shadow-xl">
                    {step.number}
                  </div>
                </div>
                <div className="flex-1 bg-gray-50 rounded-2xl p-8">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                    <h3 className="text-2xl font-bold text-[#0F5132]">{step.title}</h3>
                    <span className="inline-block px-4 py-1 bg-[#0F5132] text-white rounded-full text-sm font-medium mt-2 md:mt-0">
                      {step.duration}
                    </span>
                  </div>
                  <p className="text-gray-600 text-lg">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#0F5132] mb-6">Why Start with Shivangel?</h2>
              <div className="space-y-4">
                {[
                  'Low MOQ - Start with minimal investment',
                  'No Hidden Costs - Transparent pricing',
                  'Complete Regulatory Support',
                  '68+ Ready Formulations Available',
                  'Custom Formulation Development',
                  'Flexible Packaging Options',
                  'Fast Turnaround Time',
                  'Dedicated Account Manager',
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <FaCheckCircle className="text-[#0F5132] text-xl flex-shrink-0" />
                    <span className="text-[#0F5132] font-medium text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <EnquiryForm title="Start Your Brand Today" context="manufacturing" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StartYourBrandPage;